import React, { useCallback, useEffect, useState } from 'react';
import { Container, Grid, Paper, Typography, Button, Box, FormControlLabel, Checkbox, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOpcoesStart, fetchPlanosStart, setPlanoEscolhido } from '../../store/reducers/plano';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useSpring, animated } from 'react-spring';
import { CheckBoxOutlineBlankSharp, CheckBoxSharp, } from '@mui/icons-material';
import { adicionarCupom, limparCnpjAction, limparDadosAction, limparCupom } from '../../store/reducers/utils';
import { persistor } from '../../store';

function Planos() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { planoNome, cupom } = useParams();
    const planos = useSelector(state => state.plano.planos);
    const [planoSelecionado, setPlanoSelecionado] = useState({});
    const [opcaoSelecionada, setOpcaoSelecionada] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (cupom) {
            console.log('Cupom: ', cupom);
            dispatch(adicionarCupom(cupom));
        } else {
            console.log('Limpa cupom');
            dispatch(limparCupom());
        }
    }, []);

    useEffect(() => {
        // Limpa dados do cadastro do CNPJ
        dispatch(limparCnpjAction())
    }, [])

    const handleAgreeChange = (event) => {
        setIsChecked(event.target.checked);
    };

    useEffect(() => {
        dispatch(fetchPlanosStart());
    }, []);



    useEffect(() => {
        const alreadyCleared = localStorage.getItem("sessionCleared");

        if (!alreadyCleared) {
            localStorage.clear();

            document.cookie.split(";").forEach((c) => {
                document.cookie = c
                    .replace(/^ +/, "")
                    .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            persistor.purge();
            //dispatch(limparFiltros());

            localStorage.setItem("sessionCleared", "true");


            window.location.reload();
        }
    }, []);

    useEffect(() => {
        const planoNormalizadoNome = planoNome.toLowerCase().replace(/\s+/g, '');
        const plano = planos.find(p => p.nome.replace(/\s+/g, '').toLowerCase() === planoNormalizadoNome);

        if (planos.length > 0) {
            if (plano === undefined) {
                navigate('/NotFound');
            }
        }

        if (plano) {
            setPlanoSelecionado(plano);
            dispatch(setPlanoEscolhido(plano));
            dispatch(fetchOpcoesStart(plano.opcoes.find(opcao => opcao.recomendado)));
        }
        setLoading(false);

    }, [planoNome]);

    const handleSelecionar = (opcao) => {
        setOpcaoSelecionada(opcao.descricao)
        dispatch(fetchOpcoesStart(opcao));
    }


    const fadeIn = useSpring({ from: { opacity: -10 }, to: { opacity: 1 } });
    const slideIn = useSpring({
        from: { transform: 'translate3d(250%,0,0)' },
        to: { transform: 'translate3d(0,0,0)' },
        config: { tension: 170, friction: 26 },
    });

    if (!planoSelecionado.nome) {
        return (
            <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#FF9F0D' }} />
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 2, display: 'flex', flexDirection: 'column', mb: 2 }}>
            <Grid container justifyContent="center" direction="column" alignItems="center">
                <Grid item>
                    <Typography variant="h4" fontWeight="bolder" gutterBottom>
                        {planoSelecionado.nome.toUpperCase()}
                    </Typography>
                </Grid>
                <Grid item sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" gutterBottom sx={{ color: '#A6A6A6' }}>
                        Tecnologia fácil para quem entrega com os próprios motocas
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" sx={{ flexGrow: 0.3 }} spacing={8}>
                <Grid item xs={12} sm={12} md={6}>
                    <Grid container spacing={2}>
                        {planoSelecionado.opcoes?.map((opcao, index) => (
                            <Grid item xs={12} key={index}>
                                <animated.div style={slideIn}>
                                    <Button
                                        variant={opcaoSelecionada === opcao.descricao ? 'contained' : 'outlined'}
                                        onClick={() => handleSelecionar(opcao)}
                                        sx={{
                                            borderRadius: '10px',
                                            borderColor: '#FF9F0D',
                                            color: opcaoSelecionada === opcao.descricao ? 'white' : '#000',
                                            backgroundColor: opcaoSelecionada === opcao.descricao ? '#FF9F0D' : 'white',
                                            '&:hover': {
                                                backgroundColor: opcaoSelecionada === opcao.descricao ? '#e68a00' : '#f5f5f5',
                                                borderColor: '#e68a00',
                                            },
                                            height: '105px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '0 20px',
                                            width: '100%',
                                            position: 'relative',
                                        }}
                                    >
                                        {opcao.recomendado ? (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-15px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    backgroundColor: 'white',
                                                    borderRadius: '20px',
                                                    padding: '3px 15px',
                                                    color: '#6a0dad',
                                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                                                    fontWeight: '500',
                                                }}
                                            >
                                                ECONOMIZE
                                            </div>
                                        ) : null}
                                        {opcaoSelecionada === opcao.descricao ?
                                            <CheckCircleIcon sx={{ fontSize: '2rem', mr: 2, color: '#fff' }} /> :
                                            <RadioButtonUncheckedIcon sx={{ fontSize: '2rem', mr: 2 }} />
                                        }
                                        <Typography variant="body1" sx={{ flexGrow: 1, mx: 1 }}>
                                            {opcao.descricao}
                                        </Typography>
                                        <Box sx={{
                                            textAlign: 'left',
                                            ml: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            <Typography variant="p" sx={{ display: 'block' }}>
                                                {opcao.formasPagamento
                                                    .filter(formaPagamento => formaPagamento.formaPagamento === 'Gateway')
                                                    .map(formaPagamento => formaPagamento.numeroParcelas)
                                                    .join(',')}x
                                            </Typography>
                                            <Typography variant="h5" fontWeight="bold" sx={{ lineHeight: 1 }}>
                                                R$ {(
                                                    Number(opcao.valor) /
                                                    Number(
                                                        opcao.formasPagamento
                                                            .filter(formaPagamento => formaPagamento.formaPagamento === 'Gateway')
                                                            .map(formaPagamento => formaPagamento.numeroParcelas)[0] || 1
                                                    )
                                                )?.toFixed(2).replace('.', ',')}
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                                                ou R${opcao.valor.toFixed(2).replace('.', ',')} PIX
                                            </Typography>
                                        </Box>
                                    </Button>

                                </animated.div>

                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <Paper elevation={3} sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        minHeight: '60vh',
                        maxHeight: '110vh',
                        borderRadius: '10px',
                        backgroundColor: 'white',
                        overflow: 'auto',
                    }}>
                        <div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Quantidade de pedidos por mês: {planoSelecionado.quantidadePedidosPorMes}</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Tem cálculo de rota: {planoSelecionado.temCalculoRota ? 'Sim' : 'Não'}</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Tem despacho automático: {planoSelecionado.temDespachoAutomatico ? 'Sim' : 'Não'}</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Gestão e monitoramento de entregas e entregadores.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>

                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Integração com os principais sistemas.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Despacho automatizado.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Código de confirmação de entrega iFood via App.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Integração com Entrega fácil, Uber, Rappi e outros.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Chat interno com entregador.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Link de rastreio para seus clientes.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Até {planoSelecionado.quantidadePedidosPorMes} entregas/mês.</Typography>
                                </Box>
                            </animated.div>
                            <animated.div style={fadeIn}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleOutlineIcon sx={{ color: '#FF9F10', mr: 1 }} />
                                    <Typography>Gestão de escala e muito mais!</Typography>
                                </Box>
                            </animated.div>
                        </div>
                        <Box sx={{
                            alignSelf: 'flex-start',
                            mt: 1,
                            mb: 2,
                        }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlankSharp sx={{ color: '#A3A3A3' }} />}
                                        checkedIcon={<CheckBoxSharp sx={{ color: '#FF9F10' }} />}
                                        checked={isChecked}
                                        onChange={handleAgreeChange}
                                        name="agreeTerms"
                                    />
                                }
                                label="Estou de acordo com os termos"
                                sx={{ display: 'block' }}
                            />
                            <Typography
                                component="a"
                                href="https://pickngo.com.br/termos-de-uso/"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    textDecoration: 'underline',
                                    textDecorationColor: '#FF9F10',
                                    color: '#FF9F10',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    },
                                    display: 'block',
                                    ml: 3.7,
                                    mt: -1,
                                }}
                            >
                                Termos de uso e prestação de uso
                            </Typography>
                        </Box>
                        <Button variant="contained"
                            disabled={!isChecked}
                            sx={{
                                backgroundColor: '#ff9f10',
                                '&:hover': {
                                    backgroundColor: '#ff9f10',
                                },
                                color: 'white',
                                borderRadius: '10px',
                                height: '50px',
                                fontWeight: 'bold',
                            }}
                            onClick={() => {
                                dispatch(limparDadosAction())
                                navigate('/cadastro')
                            }}

                        >
                            Selecionar Plano
                        </Button>
                    </Paper>
                </Grid>


            </Grid>
            <Grid container justifyContent="center" alignItems="center" sx={{ mt: 2, mb: 2 }}>
                <Typography variant="body2" sx={{ mr: 1, color: '#A4A4A4' }}>Powered by</Typography>
                <img
                    style={{ width: '96px', height: '16px' }}
                    src={require('../../images/0819db8c82d9cffc3dd22bd091848a1f.png')}
                    alt="Descrição"
                />
            </Grid>
        </Container >
    );
}

export default Planos;
